var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "form",
    {
      staticClass: "credit-note",
      on: {
        submit: function($event) {
          $event.preventDefault()
          return _vm.onSubmit($event)
        }
      }
    },
    [
      _c("div", { staticClass: "container" }, [
        _c(
          "div",
          { staticClass: "columns is-multiline" },
          [
            _c(
              "div",
              { staticClass: "column is-6" },
              [
                _c("Receiver", {
                  attrs: { "is-loading": _vm.loading, disabled: _vm.disabled },
                  on: { customer: _vm.onSelectCustomer }
                })
              ],
              1
            ),
            _c(
              "div",
              { staticClass: "column is-6" },
              [
                _c("VoucherDetails", {
                  ref: "voucherDetailsComponent",
                  attrs: { "is-loading": _vm.loading, disabled: _vm.disabled },
                  on: { customer: _vm.onSelectCustomer }
                })
              ],
              1
            ),
            _c(
              "div",
              { staticClass: "column is-12" },
              [
                _c("Concepts", {
                  attrs: { "is-loading": _vm.loading, disabled: _vm.disabled },
                  on: { customer: _vm.onSelectCustomer }
                })
              ],
              1
            ),
            _c(
              "div",
              { staticClass: "column is-12" },
              [
                _c("CfdisRelatedReplacement", {
                  attrs: {
                    "replacement-type": "replacementCreditNote",
                    disabled: _vm.disabled
                  }
                })
              ],
              1
            ),
            _c("div", { staticClass: "column is-12 action-buttons" }, [
              _c("div", { staticClass: "field is-grouped" }, [
                _c("p", { staticClass: "control" }, [
                  _c(
                    "button",
                    {
                      staticClass: "button is-success",
                      class: { "is-loading": _vm.loading },
                      attrs: {
                        type: "submit",
                        disabled: _vm.loading || _vm.disabled
                      },
                      on: {
                        click: function($event) {
                          return _vm.setStamp(true)
                        }
                      }
                    },
                    [_vm._v("\n              Guardar y Timbrar\n            ")]
                  )
                ]),
                _c(
                  "p",
                  { staticClass: "control" },
                  [
                    _c(
                      "RouterLink",
                      {
                        staticClass: "button is-danger",
                        class: { "is-loading": _vm.loading },
                        attrs: { disabled: _vm.loading, to: { name: "Home" } }
                      },
                      [
                        _vm._v(
                          "\n              " +
                            _vm._s(_vm.disabled ? "Regresar" : "Cancelar") +
                            "\n            "
                        )
                      ]
                    )
                  ],
                  1
                )
              ])
            ]),
            _vm.customerInvoicesActive
              ? _c("CustomerInvoices", { attrs: { customer: _vm.customer } })
              : _vm._e(),
            _c("RouterView")
          ],
          1
        )
      ])
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }